import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Unstable_Grid2";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  cancelEdit,
  isValidCustomer,
  save,
  selectors as customerSelectors,
  selectEditedCustomerId,
  selectEditedCustomerIsNew,
  selectCustomerEditOpen,
  selectCustomerIsSaving,
} from "../redux/customers";
import CurrencyField from "./CurrencyField";
import CustomerGdsIds from "./CustomerGdsIds";
import ModalScreen from "./ModalScreen";

const EditCustomerForm = (props) => {
  const dispatch = useDispatch();

  const customer = useSelector((state) =>
    customerSelectors.selectById(state, selectEditedCustomerId(state)),
  );

  const isSaving = useSelector(selectCustomerIsSaving);

  const [name, setName] = useState(customer?.name || "");
  const [serviceFee, setServiceFee] = useState(customer?.serviceFee || "0.00");

  const customerToSave = { name, serviceFee };

  const isValid = isValidCustomer(customerToSave);

  const nameHelperText = name && !isValid ? "min 3 characters" : "";

  const onNameChange = (event) => {
    setName(event.target.value);
  };

  const onServiceFeeChange = (value) => {
    setServiceFee(value);
  };

  const onSave = () => {
    const isEdited =
      name !== customer?.name || serviceFee !== customer?.serviceFee;
    if (isEdited) {
      dispatch(save(customerToSave));
    } else {
      dispatch(cancelEdit());
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid xs={12}>
        <TextField
          autoFocus
          fullWidth
          helperText={nameHelperText}
          label="Name"
          onChange={onNameChange}
          placeholder="Customer Name (min 3 characters)"
          required
          value={name}
        />
      </Grid>
      <Grid xs={12}>
        <CurrencyField
          fullWidth
          label="Service Fee"
          onChange={onServiceFeeChange}
          required
          value={serviceFee}
        />
      </Grid>
      <Grid xs={12}>
        <Button
          className={isSaving ? "InProgress" : ""}
          fullWidth
          disabled={!isValid || isSaving}
          onClick={onSave}
        >
          {isSaving ? "Saving..." : "Save"}
        </Button>
      </Grid>
      {customer?.id && (
        <Grid xs={12}>
          <CustomerGdsIds customerId={customer.id} />
        </Grid>
      )}
    </Grid>
  );
};

const EditCustomer = (props) => {
  const dispatch = useDispatch();
  const onClose = () => dispatch(cancelEdit());
  const open = useSelector(selectCustomerEditOpen);
  const isNewCustomer = useSelector(selectEditedCustomerIsNew);
  const title = isNewCustomer ? "Add New Customer" : "Edit Customer";

  return (
    <ModalScreen open={open} onClose={onClose} title={title}>
      <EditCustomerForm onClose={onClose} />
    </ModalScreen>
  );
};

export default EditCustomer;
